<template>
  <div>
    <ib-charts-placeholder v-if="isFinancesEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="tabs"
    >
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <cash-flow-from-financing-activities v-if="activeTab === 'first'" chart-animations />
        </div>
      </el-tab-pane>

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <financing-sources v-if="activeTab === 'second'" chart-animations />
        </div>
      </el-tab-pane>

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <financing-table />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import CashFlowFromFinancingActivities from '@/views/Home/StoryMode/FinancialPlan/Components/Financing/CashFlowFromFinancingActivities.vue'
import FinancingSources from '@/views/Home/StoryMode/FinancialPlan/Components/Financing/FinancingSources.vue'
import FinancingTable from '@/views/Home/StoryMode/SetUp/Financing/Tables/FinancingTable.vue'

export default {
  name: 'FinancingTabs',
  components: { FinancingTable, CashFlowFromFinancingActivities, FinancingSources },

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    isFinancesEmpty () {
      return this.idea.storyMode.setUp.financing.finances.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
